export var menuDefaultTheme = {
  Root: {
    base: {
      backgroundColor: '$color.neutral.00'
    },
    bottomSeparator: {
      borderBottomColor: '$color.neutral.03'
    },
    secondary: {
      backgroundColor: '$color.neutral.01'
    },
    tertiary: {
      backgroundColor: '$color.neutral.01'
    }
  }
};